import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('pqPprRptGrpStore', Object.keys(getters)),
	...mapState('pqPprRptGrpStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('pqPprRptGrpStore', Object.keys(actions)),
	...mapMutations('pqPprRptGrpStore', Object.keys(mutations))
};
